import * as config from '../../../../package.json';
export const VERSION = config.version;
